<template>
    <div class="mx-auto fixed-width-form">
        <legend>Изменить статус - {{status.Name}}</legend>
        <form action="post" @submit.prevent="setStatus">
            <div class="form-group">
                <div class="input-group">
                    <input type="number" class="form-control" placeholder="Номер сферы" v-model="sferaNumber">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="submit">Отправить</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>

import { get, post } from '@/admin/services/api/http-utils';

export default {
  components: {},
  data() {
    return {
      status: '',
      sferaNumber: '',
    };
  },
  async created() {
    const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order-status/by-code/${this.$route.params.code}`);
    this.status = data;
  },
  methods: {
    async setStatus() {
      try {
        await post(`${process.env.VUE_APP_API_HOST}admin/order-status/set-status`, {
          status: this.status,
          sferaNumber: this.sferaNumber,
        });
        this.$toasted.show('Статус изменен', { type: 'success' });
        this.sferaNumber = '';
      } catch (error) {
        this.$toasted.show('Ошибка', { type: 'error' });
      }
    },
  },
};
</script>
